import { Button, Modal, Table, message } from "antd";
import ShippingAddress from "../components/order/ShippingAddress";
import BillAddress from "../components//order/BillAddress";
import OrderSumCard from "../components//order/OrderSumCard";
import OrderInfoCard from "../components/order/OrderInfoCard";
import EmailCard from "../components/order/EmailCard";
import ConfirmChannelCard from "../components//order/ConfirmChannelCard";
import { AppContext } from "../store";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import SCIcon from "../components/common/SCIcon";
import PriceWidget from "../components/activity/PriceWidget";
import defaultImg from "../images/default-brand.jpg";
import { isValidEmail, getAuthToken, debounce } from "../utils/common";
import {
  getSelectedSTObj,
  getSelectedBTObj,
  getContact,
  getContactPhoneForChannel,
  validateContact,
  isValidChinesePhoneWithCountryCode,
} from "../utils/addressUtils";
import Header from "../components/common/Header";
import axios from "axios";
import {
  enableOrderPreviewCRD,
  orderConfirmUrl,
  productCRDRangeUrl,
  submitOrderUrl,
  USER_TYPE,
  ORDER_CHANNEL,
  NOTIFICATION_METHOD,
  openTfsRuleUrl,
  openTfsChangeRuleUrl,
  AMOUNT_EXCEEDS_LIMIT,
  ACTIVITY_NO_PERMISSION_STATUS_VALUE,
  getActivityNoPermissionStatusLabel,
} from "../utils/constant";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { gotoPdp, submitOrderErrorHandle } from "../utils/activityHelper";
import Loading from "../components/common/Loading";
import { CaretRightOutlined } from "@ant-design/icons";
import { pageDetailsDataPush } from "Utils/analyticsUtils";
import { decrypt } from "Utils/crypto";
import { submitOrderEvent } from "Utils/aaUtils";
import OrderPreviewCRDModal, {
  CRDEditTrigger,
} from "Components/order/OrderPreviewCRDModal";
import {
  applyCRDSelection,
  buildCRDRangeRequest,
  mergeCRDRangeData,
  normalizeOrderLinesForSubmit,
} from "Utils/orderPreviewCRD";

const formatPhone = (phone: string) => {
  const digits = (phone || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("86") && digits.length > 11) {
    return digits.slice(-11);
  }
  if (digits.length > 11) return digits.slice(-11);
  return digits;
};

const OrderPreview: React.FC = () => {
  const { loginState, selectedAddressKey, refreshCartData, cartData } =
    useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { activityId } = useParams<{ activityId: string }>();
  const { activityPermissionMeta } = useContext(AppContext);
  const activityNoPermissionLabel = getActivityNoPermissionStatusLabel(
    activityPermissionMeta.activityId === activityId
      ? activityPermissionMeta.customerDataType
      : undefined
  );
  const [previewReqbody, setPreviewReqbody] = useState<any>(null);
  const [previewData, setPreviewData] = useState<any>(null);
  const [stContact, setStContact] = useState<string>("");
  const [invalidStContacMsg, setInvalidStContacMsg] = useState<string>("");
  const [billContact, setBillContact] = useState<string>("");
  const [invalidBtContacMsg, setInvalidBtContacMsg] = useState<string>("");
  const [inOrderNumber, setInOrderNumber] = useState<string>("");
  const [remark, setRemark] = useState<string>("");
  const [emails, setEmails] = useState<string[]>([""]);
  const [loading, setLoading] = useState<boolean>(true);
  const [showSTSelector, setShowSTSelector] = useState<boolean>(false);
  const [stickPosition, setStickyPosition] = useState<any>({
    position: "sticky",
    top: "0px",
  });
  const [resetContactInfo, setResetContactInfo] = useState<number>(1);
  const [confirmChannels, setConfirmChannels] = useState<{
    app: boolean;
    sms: boolean;
    mail: boolean;
  }>({
    app: true,
    sms: false,
    mail: false,
  });
  const [confirmSms, setConfirmSms] = useState<string>("");
  const [confirmEmail, setConfirmEmail] = useState<string>("");
  const [showAmountExceedsLimitModal, setShowAmountExceedsLimitModal] = useState<boolean>(false);
  const [crdHolidays, setCRDHolidays] = useState<string[]>([]);
  const [openCRDModal, setOpenCRDModal] = useState<boolean>(false);
  const [currentCRDProduct, setCurrentCRDProduct] = useState<any>(null);
  const crdRequestKeyRef = useRef("");

  const selectedST = getSelectedSTObj(loginState);
  const selectedBT = getSelectedBTObj(loginState);
  const canShowCRD = enableOrderPreviewCRD && !!previewReqbody?.shipTo;

  const needConfirmChannelModule =
    loginState.userType === USER_TYPE.EMPLOYEE &&
    loginState?.proxyUser?.orderChannel === ORDER_CHANNEL.ONLINE;

  const isScEmployeeModule = loginState.userType === USER_TYPE.EMPLOYEE;

  const updatePreviewData = (respData: any) => {
    setPreviewData({
      ...respData,
      products: normalizeOrderLinesForSubmit(respData?.products || []),
    });
    crdRequestKeyRef.current = "";
  };

  const smsCandidates = useMemo(() => {
    if (!needConfirmChannelModule) return [];
    const phoneFromAddress = getContactPhoneForChannel(selectedST, loginState?.user);
    const phoneFromUser = loginState?.user?.user?.contactInfo?.phone;
    const phoneFromContactInput = (() => {
      if (!stContact) return "";
      const cleaned = stContact.replace(/[()\uFF08\uFF09]/g, "");
      const parts = cleaned.split(/[,，\s+]/).filter(Boolean);
      return parts.length ? parts[parts.length - 1] : "";
    })();

    let receiverTelephone = phoneFromAddress;
    const contactInputValid =
      phoneFromContactInput &&
      isValidChinesePhoneWithCountryCode(phoneFromContactInput.replace(/[()\uFF08\uFF09]/g, "").trim());
    if (contactInputValid && phoneFromContactInput.replace(/[()\uFF08\uFF09]/g, "") !== phoneFromAddress) {
      receiverTelephone = phoneFromContactInput;
    }
    const list = [receiverTelephone, phoneFromUser];
    return Array.from(
      new Set(
        list
          .filter(Boolean)
          .map((p) => formatPhone(p))
          .filter(Boolean)
      )
    );
  }, [needConfirmChannelModule, selectedST, loginState, stContact]);

  const columns = useMemo(() => {
    const tableColumns: any[] = [
      {
        title: "",
        dataIndex: "img",
        key: "img",
        render: (_text: any, record: any) => {
          const imgUrl = record.product.productPic || defaultImg;
          return (
            <div
              style={{
                width: "76px",
                height: "76px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                alt=""
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                }}
                src={imgUrl}
                onClick={() => {
                  gotoPdp(record.product, loginState, "Order_Confirmation");
                }}
              />
            </div>
          );
        },
      },
      {
        title: "货号",
        dataIndex: "sku",
        key: "sku",
        className: "sku",
      },
      {
        title: "产品名称",
        dataIndex: "productName",
        key: "productName",
        className: "productName",
        width: 320,
        render: (_text: any, record: any) => {
          const pdpViewable = record.product.pdpViewable;
          return (
            <span
              className={pdpViewable ? "textLink" : ""}
              onClick={() => {
                gotoPdp(record.product, loginState, "Order_Confirmation");
              }}
              dangerouslySetInnerHTML={{
                __html: record.product.productName,
              }}
            ></span>
          );
        },
      },
      {
        title: "规格",
        dataIndex: "productSize",
        key: "productSize",
        className: "size",
        render: (_text: any, record: any) => record.product.productSize,
      },
      {
        title: "配送方式",
        dataIndex: "delivery",
        key: "delivery",
        className: "delivery",
        width: 100,
        render: (_text: any, record: any) => {
          if (record.product.deliveryChannel === "SC") {
            return <SCIcon />;
          }
          return "";
        },
      },
      {
        title: "数量",
        dataIndex: "quantity",
        key: "quantity",
        className: "quantity",
        width: 80,
      },
      {
        title: "价格",
        dataIndex: "price",
        key: "price",
        className: "price",
        width: 170,
        render: (_text: any, record: any) => {
          return (
            <PriceWidget
              product={record.product as any}
              loginState={loginState}
              cartData={cartData}
              previewData={previewData}
              isOrderPreviewFlag={true}
            ></PriceWidget>
          );
        },
      },
    ];

    if (canShowCRD) {
      tableColumns.push({
        title: "期望发货日期",
        dataIndex: "crd",
        key: "crd",
        className: "crd",
        width: 150,
        render: (_text: any, record: any) => {
          if (record.CRD_Range?.status !== "eligible") {
            return <span>{record.crd || "-"}</span>;
          }
          return (
            <CRDEditTrigger
              value={record.crd}
              onClick={() => {
                setCurrentCRDProduct(record);
                setOpenCRDModal(true);
              }}
            />
          );
        },
      });
    }

    return tableColumns;
  }, [canShowCRD, cartData, loginState, previewData]);

  const handleScroll = useCallback(
    debounce(() => {
      const scrollTop = (
        document.documentElement ||
        document.body.parentNode ||
        document.body
      ).scrollTop;

      const scrollHeight = (
        document.documentElement ||
        document.body.parentNode ||
        document.body
      ).scrollHeight;

      const clientHeight =
        document.documentElement.clientHeight || window.innerHeight;

      const scrolledToBottom =
        Math.ceil(scrollTop + clientHeight) >= scrollHeight;
      const relativeWrapper = document.querySelector(
        ".pageContent"
      ) as HTMLElement;
      const wrapperHeight = relativeWrapper.getBoundingClientRect().height;
      const element = document.querySelector(".orderSumWrapper") as HTMLElement;
      const height = element.getBoundingClientRect().height;
      if (scrollTop <= 110) {
        setStickyPosition({
          position: "sticky",
          top: "0px",
          transition: "top 0.3s ease-in-out",
        });
      } else if (scrolledToBottom) {
        setStickyPosition({
          position: "sticky",
          top: wrapperHeight - height + "px",
          transition: "top 0.3s ease-in-out",
        });
      } else {
        setStickyPosition({
          position: "sticky",
          top: `calc(50vh - ${height / 2}px)`,
          transition: "top 0.3s ease-in-out",
        });
      }
    }, 200),
    []
  );

  useEffect(() => {
    const temp = localStorage.getItem(`${activityId}OrderPreviewData`);
    const encryptedData = temp && JSON.parse(temp);
    if (!encryptedData) {
      navigate(-1);
      return;
    }
    decrypt(encryptedData)
      .then((decryptedStr) => {
        const data = JSON.parse(decryptedStr);
        updatePreviewData(data.respData);
        setPreviewReqbody(data.reqBody);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
    window.addEventListener("scroll", handleScroll);
    (window as any).currentCampaignId = activityId;
    pageDetailsDataPush({
      type: "campaigns",
      name: "campaigns:orderConfirmation",
    });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      localStorage.removeItem(`${activityId}OrderPreviewData`);
    };
  }, [activityId, handleScroll, navigate]);

  useEffect(() => {
    const shipToNum = previewReqbody?.shipTo;
    const authToken = getAuthToken();
    if (
      !enableOrderPreviewCRD ||
      !authToken ||
      !previewData?.products?.length ||
      !shipToNum
    ) {
      return;
    }
    const reqBody = buildCRDRangeRequest({
      shipToNum,
      supplyCenterId: previewData.supplyCenterId,
      products: previewData.products,
    });
    if (!reqBody.items.length) {
      return;
    }
    const requestKey = JSON.stringify({
      shipToNum: reqBody.shipToNum,
      supplyCenterId: reqBody.supplyCenterId,
      items: reqBody.items,
    });
    if (crdRequestKeyRef.current === requestKey) {
      return;
    }
    crdRequestKeyRef.current = requestKey;
    axios(productCRDRangeUrl, {
      method: "POST",
      headers: {
        Authorization: authToken,
        "Content-Type": "application/json",
      },
      data: reqBody,
    })
      .then((resp) => {
        if (crdRequestKeyRef.current !== requestKey) {
          return;
        }
        const respData = resp.data;
        if (respData?.status !== "success") {
          crdRequestKeyRef.current = "";
          setCRDHolidays([]);
          return;
        }
        setCRDHolidays(respData.data?.holidays || []);
        setPreviewData((prev: any) => {
          if (!prev) return prev;
          return {
            ...prev,
            products: mergeCRDRangeData(prev.products, respData.data),
          };
        });
      })
      .catch(() => {
        if (crdRequestKeyRef.current !== requestKey) {
          return;
        }
        crdRequestKeyRef.current = "";
        setCRDHolidays([]);
      });
  }, [previewData?.products, previewData?.supplyCenterId, previewReqbody?.shipTo]);

  useEffect(() => {
    if (loginState.status !== "login") return;
    const currentSelectedST = getSelectedSTObj(loginState);
    const currentSelectedBT = getSelectedBTObj(loginState);
    if (isScEmployeeModule && !currentSelectedST?.attentionTo) {
      setStContact("");
    } else {
      setStContact(getContact(currentSelectedST, loginState.user));
    }
    if (isScEmployeeModule && !currentSelectedBT?.attentionTo) {
      setBillContact("");
    } else {
      setBillContact(getContact(currentSelectedBT, loginState.user));
    }
  }, [loginState, resetContactInfo, isScEmployeeModule, selectedAddressKey]);

  useEffect(() => {
    if (loginState?.status !== "login") return;
    const phone = loginState?.user?.user?.contactInfo?.phone || "";
    const email = loginState?.user?.user?.contactInfo?.primaryEmail || "";
    setConfirmSms(formatPhone(phone));
    setConfirmEmail(email);
  }, [loginState]);

  type ConfirmChannelKey = "app" | "sms" | "mail";
  const handleChannelChange = (key: ConfirmChannelKey) => {
    setConfirmChannels((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const gotoOrderConfirm = (stItem: any, preSelectedAddressKey?: any) => {
    setShowSTSelector(false);
    if (stItem?.addressKey?.toString() === preSelectedAddressKey?.toString()) {
      return;
    }
    const currentSelectedST = getSelectedSTObj(loginState);
    const currentSelectedBT = getSelectedBTObj(loginState);

    if (isScEmployeeModule && !currentSelectedST?.attentionTo) {
      setStContact("");
    } else {
      setStContact(getContact(currentSelectedST, loginState.user));
    }
    if (isScEmployeeModule && !currentSelectedBT?.attentionTo) {
      setBillContact("");
    } else {
      setBillContact(getContact(currentSelectedBT, loginState.user));
    }

    setLoading(true);
    const nextPreviewReqbody = { ...previewReqbody, shipTo: stItem?.shipTo || "" };
    axios(orderConfirmUrl, {
      method: "POST",
      headers: {
        Authorization: getAuthToken(),
        "Content-Type": "application/json",
      },
      data: nextPreviewReqbody,
    })
      .then((resp) => {
        if (resp.status === 200) {
          const respData = resp.data;
          if (respData?.status === "success") {
            respData.data.activityId = activityId;
            setLoading(false);
            if (!respData.data?.matchStatus) {
              Modal.confirm({
                className: "confirmModal",
                style: { top: "32vh" },
                title: "请确认地址更改？",
                content:
                  "地址更改后，活动优惠重新计算，请返回上一个页面确认优惠明细",
                okText: "返回上一页",
                cancelText: "不更改地址",
                onOk() {
                  const searchParams = new URLSearchParams(location.search);
                  navigate(`/${activityId}?${searchParams.toString()}`, {
                    replace: true,
                    state: { openCartDrawer: true },
                  });
                },
                onCancel() {
                  localStorage.setItem(
                    "selectedAddressKey",
                    preSelectedAddressKey || ""
                  );
                  setPreviewData((prev: any) => ({ ...prev }));
                  setResetContactInfo((prev) => prev + 1);
                },
              });
              return;
            }
            setPreviewReqbody(nextPreviewReqbody);
            updatePreviewData(respData.data);
          } else if (respData?.status === ACTIVITY_NO_PERMISSION_STATUS_VALUE) {
            message.warning(activityNoPermissionLabel);
            setLoading(false);
          } else {
            message.error("操作失败，请联系在线客服");
            setLoading(false);
          }
        } else {
          message.error("操作失败，请联系在线客服");
          setLoading(false);
        }
      })
      .catch(() => {
        message.error("操作失败，请联系在线客服");
        setLoading(false);
      });
  };

  const handleCRDSubmit = (payload: {
    newCrd: string;
    selectedLinesMap: Record<string, string>;
  }) => {
    setPreviewData((prev: any) => {
      if (!prev) return prev;
      return {
        ...prev,
        products: applyCRDSelection(prev.products, payload),
      };
    });
    setOpenCRDModal(false);
    setCurrentCRDProduct(null);
  };

  const submitOrder = () => {
    if (loading) {
      message.warning("请勿重复提交订单");
      return;
    }
    const temp2: any = localStorage.getItem(`${activityId}OrderPreviewData`);
    if (!temp2) {
      message.error(
        "订单数据丢失，请重新选择商品， 或者请勿打开多个订单提交页面"
      );
      return;
    }
    if (previewData.total === "0" || previewData.total === "0.0" || previewData.total === "0.00") {
      return message.warning("当前订单金额为0, 无法提交订单");
    }
    const res = validateContact(stContact);
    const res2 = validateContact(billContact);
    if (!res.isValid) {
      setInvalidStContacMsg(res.errMsg || "请输入正确的联系方式,格式: 姓名,电话");
    }
    if (!res2.isValid) {
      setInvalidBtContacMsg(res2.errMsg || "请输入正确的联系方式,格式: 姓名,电话");
    }
    if (!res.isValid || !res2.isValid) {
      return;
    }
    const emailList = emails.filter((email) => email.trim());
    const valid3 = emailList.every((email) => {
      return isValidEmail(email);
    });
    if (!valid3) {
      return;
    }

    const parseAmount = (value?: string | number) => {
      if (!value) return 0;
      if (typeof value === "number") return value;
      return parseFloat(String(value).replace(/,/g, "")) || 0;
    };

    const isEmployeeOffline =
      loginState.userType === USER_TYPE.EMPLOYEE &&
      loginState?.proxyUser?.orderChannel === ORDER_CHANNEL.OFFLINE;
    const payableAmount = parseAmount(previewData.total);

    if (isEmployeeOffline && payableAmount > AMOUNT_EXCEEDS_LIMIT) {
      setShowAmountExceedsLimitModal(true);
      return;
    }
    if (needConfirmChannelModule) {
      const formattedSms = formatPhone(confirmSms);
      const formattedCandidates = smsCandidates
        .map((p) => formatPhone(p))
        .filter(Boolean);
      if (confirmChannels.sms && !confirmSms) {
        message.warning("请填写短信手机号或取消短信渠道选择");
        return;
      }
      if (confirmChannels.mail && !confirmEmail) {
        message.warning("请填写邮件地址或取消邮件渠道选择");
        return;
      }
      if (
        confirmChannels.sms &&
        formattedSms &&
        !formattedCandidates.includes(formattedSms)
      ) {
        message.warning(
          "提醒：短信通知电话必须是收件人联系方式或者账户默认联系方式，请检查并更新您选择的联系方式"
        );
        return;
      }
    }

    interface NotificationMethod {
      method: typeof NOTIFICATION_METHOD[keyof typeof NOTIFICATION_METHOD];
      receiver: string;
    }

    interface SubmitOrderBody {
      activityId: string;
      tieredRuleId: any;
      matchStatus: any;
      shipTo: any;
      prePaymentAccount: any;
      customerPrimaryEmail: any;
      paymentNumber: any;
      additionalEmail: string[];
      siebelRowId: any;
      supplyCenterId: any;
      remark: any;
      orderLines: any;
      addresses: any[];
      userKey?: number;
      userName?: string;
      priceDisplayFlag?: string;
      orderChannel?: typeof ORDER_CHANNEL[keyof typeof ORDER_CHANNEL];
      confirmChannels?: { app: boolean; sms: boolean; mail: boolean };
      confirmSms?: string;
      confirmEmail?: string;
      notificationMethods?: NotificationMethod[];
    }

    const reqBody: SubmitOrderBody = {
      activityId: "",
      tieredRuleId: previewReqbody.tieredRuleId,
      matchStatus: previewData.matchStatus,
      shipTo: selectedST?.accountNumber,
      prePaymentAccount: selectedBT.prePaymentAccount,
      customerPrimaryEmail: loginState?.user?.user.contactInfo.primaryEmail,
      paymentNumber: inOrderNumber,
      additionalEmail: emails,
      siebelRowId: loginState?.user?.user?.siebelRowId,
      supplyCenterId: previewData.supplyCenterId,
      remark: remark,
      orderLines: normalizeOrderLinesForSubmit(previewData.products),
      addresses: [
        {
          addressKey: selectedST.addressKey,
          attentionLine: res.value,
          accountId: selectedST?.accountNumber,
          accountName: selectedST.companyOrInstitution,
          address1: selectedST.deptOrLab || null,
          address2: selectedST.buildingOrRoom || null,
          address3: selectedST.streetAddress || null,
          countryCode: selectedST.isoCountryCode,
          country: selectedST.country,
          city: selectedST.city,
          addressType: "SHIP_TO",
          billToId: selectedST.relatedBillTo,
        },
        {
          attentionLine: res2.value,
          address1: selectedBT.deptOrLab || null,
          address2: selectedBT.buildingOrRoom || null,
          address3: selectedBT.streetAddress || null,
          accountName: selectedBT.companyOrInstitution,
          countryCode: selectedBT.isoCountryCode,
          city: selectedBT.city,
          addressType: "BILL_TO",
          addressKey: selectedBT.addressKey,
          accountId: selectedBT.accountNumber,
        },
      ],
      userKey: isScEmployeeModule ? undefined : loginState?.user?.user?.userId,
      userName: loginState?.user?.user?.userName,
      priceDisplayFlag: selectedST?.priceDisplayFlag,
    };
    if (loginState.userType === USER_TYPE.EMPLOYEE) {
      const channel = loginState?.proxyUser?.orderChannel;
      if (channel === ORDER_CHANNEL.ONLINE) {
        reqBody.orderChannel = ORDER_CHANNEL.ONLINE;
        const notificationMethods: NotificationMethod[] = [];
        if (confirmChannels.mail && confirmEmail) {
          notificationMethods.push({ method: NOTIFICATION_METHOD.MAIL, receiver: confirmEmail });
        }
        if (confirmChannels.sms && confirmSms) {
          notificationMethods.push({ method: NOTIFICATION_METHOD.SMS, receiver: confirmSms });
        }
        if (notificationMethods.length) {
          reqBody.notificationMethods = notificationMethods;
        }
      } else if (channel === ORDER_CHANNEL.OFFLINE) {
        reqBody.orderChannel = ORDER_CHANNEL.OFFLINE;
      }
    }

    setLoading(true);
    axios(submitOrderUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthToken(),
      },
      data: reqBody,
    })
      .then((resp) => {
        const respData = resp.data;
        if (respData.status === "success") {
          message.success("提交订单成功！");
          setLoading(false);
          refreshCartData();
          const searchParams = new URLSearchParams(location.search);
          submitOrderEvent(activityId, previewData);
          navigate(`/success?${searchParams.toString()}`, {
            state: {
              activityId: previewData.activityId,
              data: respData.data,
              hasShipTo: selectedST?.accountNumber,
              payableTotal: payableAmount,
            },
          });
          return;
        }
        if (respData?.status === ACTIVITY_NO_PERMISSION_STATUS_VALUE) {
          message.warning(activityNoPermissionLabel);
          setLoading(false);
          return;
        }
        submitOrderErrorHandle(respData, message);
        setLoading(false);
      })
      .catch(() => {
        message.error("提交订单失败, 请重试！");
        setLoading(false);
      });
  };

  if (!previewData) {
    if (loading) return <Loading />;
    navigate(-1);
    return (
      <>
        <div>请去到详情页面</div>
      </>
    );
  }

  const cartTitle = previewData.activityBasicType === "bundle_promotion" ? "已选套装" : "已选产品";
  return (
    <>
      <Header onSTClick={gotoOrderConfirm} page="Order_Confirmation" />
      <div className="pageContentContainer orderPreviewPage">
        <div className="breadCrumbsWrapper" style={{ paddingTop: "14px" }}>
          <span
            className="textLink"
            onClick={() => {
              navigate(-1);
            }}
          >
            {cartTitle}
          </span>
          <span>
            <CaretRightOutlined />
          </span>
          <span style={{ color: "#1b1b1d" }}>组合结算</span>
        </div>
        <div className="pageContent">
          <div className="leftWrapper">
            <div className="cardListWrapper">
              <div className="cardWrapper">
                <ShippingAddress
                  userId={loginState?.user?.user?.userId}
                  errMsg={invalidStContacMsg}
                  setErrMsg={setInvalidStContacMsg}
                  selectedST={selectedST}
                  stContact={stContact}
                  setStContact={setStContact}
                  showSTSelector={showSTSelector}
                  setShowSTSelector={setShowSTSelector}
                  onSTClick={gotoOrderConfirm}
                />
              </div>
              <div className="cardWrapper">
                <BillAddress
                  errMsg={invalidBtContacMsg}
                  setErrMsg={setInvalidBtContacMsg}
                  selectedBT={selectedBT}
                  billContact={billContact}
                  setBillContact={setBillContact}
                />
              </div>
              <div className="cardWrapper">
                <OrderInfoCard
                  inOrderNumber={inOrderNumber}
                  setInOrderNumber={setInOrderNumber}
                  remark={remark}
                  setRemark={setRemark}
                />
              </div>
              <div className="cardWrapper">
                <EmailCard
                  primaryEmail={loginState?.user?.user?.contactInfo.primaryEmail}
                  emails={emails}
                  setEmails={setEmails}
                />
              </div>
            </div>
            <div className="productsWrapper">
              <div className="productsTitle">产品详情</div>
              <Table
                className="productsTable"
                rowKey={(record: any) => record.lineNumber}
                columns={columns}
                dataSource={previewData.products}
                pagination={false}
              ></Table>
            </div>
          </div>
          <div className="orderSumWrapper" style={stickPosition}>
            {needConfirmChannelModule && (
              <ConfirmChannelCard
                confirmChannels={confirmChannels}
                confirmSms={confirmSms}
                confirmEmail={confirmEmail}
                smsCandidates={smsCandidates}
                onChannelChange={handleChannelChange}
                onSmsChange={setConfirmSms}
                onEmailChange={setConfirmEmail}
              />
            )}
            <OrderSumCard priceData={previewData} submitOrder={submitOrder} />
          </div>
        </div>
        <Modal
          title="订单无法提交"
          open={showAmountExceedsLimitModal}
          getContainer={document.body}
          onCancel={() => setShowAmountExceedsLimitModal(false)}
          className="show-go-to-detail-info-modal amount-exceeds-limit-modal"
          footer={[
            <Button key="cancel" type="primary" className="goback-btn" onClick={() => setShowAmountExceedsLimitModal(false)}>
              返回
            </Button>,
          ]}
        >
          <div>
            <p>
              根据赛默飞销售条款，单笔订单超6万金额，无法在本系统入单，您可返回购物车进行调整或准备好以下入单材料进行其他渠道入单
            </p>
            <p>
              1.请遵守《
              <label>
                <a
                  className="tfs-rule"
                  href={openTfsRuleUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  销售订单入单制度
                </a>
              </label>
              》，确保入单支持文件齐全，且须与客户签订双章销售合同。
            </p>
            <p>
              2.发货地址变更时，请按照公司《
              <label>
                <a
                  className="tfs-rule"
                  href={openTfsChangeRuleUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  交货地址变更政策
                </a>
              </label>
              》提供符合要求的地址确认文件。
            </p>
          </div>
        </Modal>
      </div>
      <OrderPreviewCRDModal
        open={openCRDModal}
        currentProduct={currentCRDProduct}
        products={previewData.products}
        holidays={crdHolidays}
        onClose={() => {
          setOpenCRDModal(false);
          setCurrentCRDProduct(null);
        }}
        onSubmit={handleCRDSubmit}
      />
      {loading && <Loading />}
    </>
  );
};

export default OrderPreview;
